import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from 'shared/shared.module';
import { ScorecardModule } from 'shared/scorecard/scorecard.module';
import { SideDrawerService } from 'shared/sidedrawer/sidedrawer.service';

import { DashboardRoutingModule } from './dashboard-routing.module';

// components
import { DashboardComponent } from './dashboard.component';
import { DashboardSearchService } from './components/dashboard-search/dashboard-search.service';
import { DashboardCommentsComponent } from './components/dashboard-comments/dashboard-comments.component';
import { DashboardSearchComponent } from './components/dashboard-search/base/dashboard-search.component';
import { DashboardSearchTotalComponent } from './components/dashboard-search/dashboard-search-total.component';
import { DashboardSearchDraftComponent } from './components/dashboard-search/dashboard-search-draft.component';
import { DashboardSearchReviewComponent } from './components/dashboard-search/dashboard-search-review.component';
import { DashboardSearchApprovedComponent } from './components/dashboard-search/dashboard-search-approved.component';
import { DashboardSearchPublishedComponent } from './components/dashboard-search/dashboard-search-published.component';
import { DashboardSearchInvalidPhotoComponent } from './components/dashboard-search/dashboard-search-invalid-photo.component';
import { DashboardSearchInvalidFitmentsComponent } from './components/dashboard-search/dashboard-search-invalid-fitments.component';
import { DashboardSearchValidationErrorsComponent } from './components/dashboard-search/dashboard-search-validation-errors.component';
import { DashboardSearchPiesErrorsComponent } from './components/dashboard-search/dashboard-search-pies-errors.component';
import { DashboardSearchPies65ErrorsComponent } from './components/dashboard-search/dashboard-search-pies65-errors.component';
import { DashboardSearchPies67ErrorsComponent } from './components/dashboard-search/dashboard-search-pies67-errors.component';
import { DashboardSearchPies70ErrorsComponent } from './components/dashboard-search/dashboard-search-pies70-errors.component';
import { DashboardSearchLastUpdatedComponent } from './components/dashboard-search/dashboard-search-last-updated.component';
import { DashboardSearchLastCreatedComponent } from './components/dashboard-search/dashboard-search-last-created.component';
import { DashboardSearchReceiversMyComponent } from './components/dashboard-search/dashboard-search-receivers-my.component';
import { DashboardSearchReceiversRequestedComponent } from './components/dashboard-search/dashboard-search-receivers-requested.component';
import { DashboardScorecardComponent } from './components/dashboard-scorecard/dashboard-scorecard.component';
import {
  DashboardSearchInvalidFitmentPartTypesComponent
} from './components/dashboard-search/dashboard-search-invalid-fitment-part-types.component';
import { DashboardSearchInvalidQualifiersComponent } from './components/dashboard-search/dashboard-search-invalid-qualifiers.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DashboardRoutingModule,
        SharedModule,
        ScorecardModule,
    ],
    declarations: [
        DashboardComponent,
        DashboardCommentsComponent,
        DashboardSearchComponent,
        DashboardSearchTotalComponent,
        DashboardSearchDraftComponent,
        DashboardSearchReviewComponent,
        DashboardSearchApprovedComponent,
        DashboardSearchPublishedComponent,
        DashboardSearchInvalidPhotoComponent,
        DashboardSearchInvalidFitmentsComponent,
        DashboardSearchInvalidFitmentPartTypesComponent,
        DashboardSearchInvalidQualifiersComponent,
        DashboardSearchValidationErrorsComponent,
        DashboardSearchPiesErrorsComponent,
        DashboardSearchPies65ErrorsComponent,
        DashboardSearchPies67ErrorsComponent,
        DashboardSearchPies70ErrorsComponent,
        DashboardSearchLastUpdatedComponent,
        DashboardSearchLastCreatedComponent,
        DashboardSearchReceiversMyComponent,
        DashboardSearchReceiversRequestedComponent,
        DashboardScorecardComponent
    ],
    exports: [DashboardComponent],
    providers: [DashboardSearchService, SideDrawerService]
})
export class DashboardModule { }
